export default __webpack_public_path__ + "static/media/pro-elevate-dmb-2.e7097032.png";